import { useAuth } from 'app/providers/auth/AuthProvider'
import { useCallback, useEffect, useState } from 'react'
import {
  getScheduleColumnWidthOverrides,
  setScheduleColumnWidthOverride,
  type ScheduleColumnWidthView,
} from './scheduleColumnWidthsStorage'

/**
 * Per-user schedule column width preferences (reference scale at default zoom),
 * persisted in localStorage.
 */
export const useScheduleColumnWidths = (view: ScheduleColumnWidthView) => {
  const { userId } = useAuth()
  const [referenceWidthByColumn, setReferenceWidthByColumn] = useState<Record<string, number>>(
    () => getScheduleColumnWidthOverrides(userId, view),
  )

  useEffect(() => {
    setReferenceWidthByColumn(getScheduleColumnWidthOverrides(userId, view))
  }, [userId, view])

  const setColumnReferenceWidth = useCallback(
    (columnKey: string, referenceWidthPx: number) => {
      const next = setScheduleColumnWidthOverride(userId, view, columnKey, referenceWidthPx)
      setReferenceWidthByColumn(next)
    },
    [userId, view],
  )

  return { referenceWidthByColumn, setColumnReferenceWidth }
}
